import { render, staticRenderFns } from "./pro_pro_page_dual.vue?vue&type=template&id=4716c05f&scoped=true"
import script from "./pro_pro_page_dual.vue?vue&type=script&lang=js"
export * from "./pro_pro_page_dual.vue?vue&type=script&lang=js"
import style0 from "./pro_pro_page_dual.vue?vue&type=style&index=0&id=4716c05f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4716c05f",
  null
  
)

export default component.exports